(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initAboutPage(root = document) {
    const pages = root.matches?.('.cg-about') ? [root] : root.querySelectorAll?.('.cg-about');
    if (!pages) return;

    pages.forEach((aboutPage) => {
      if (aboutPage.dataset.motionInitialized === 'true') return;
      aboutPage.dataset.motionInitialized = 'true';

      const parallaxArea = aboutPage.querySelector('[data-cg-parallax]');
      const panel = aboutPage.querySelector('[data-cg-panel]');
      const heroCharacter = aboutPage.querySelector('[data-cg-character]');

      if (parallaxArea && panel && !reduceMotion.matches) {
        parallaxArea.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch') return;
          const rect = parallaxArea.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - 0.5;
          const y = (event.clientY - rect.top) / rect.height - 0.5;
          panel.style.transform = `rotate(${2 + x * 2.5}deg) translate(${x * 10}px, ${y * 8}px)`;
          if (heroCharacter) {
            heroCharacter.style.transform = `translate(${x * 16}px, ${y * 12}px) rotate(${x * 1.2}deg)`;
          }
        });
        parallaxArea.addEventListener('pointerleave', () => {
          panel.style.transform = 'rotate(2deg)';
          if (heroCharacter) heroCharacter.style.transform = '';
        });
      }

      const bubble = aboutPage.querySelector('[data-cg-bubble]');
      if (bubble && !reduceMotion.matches) {
        const messages = [
          'This was supposed to be a sticker company.',
          'Everything is fine adjacent.',
          'Please stop perceiving us.',
          'No inner peace was found.',
          'Somehow, this became a real company.'
        ];
        let index = 0;
        window.setInterval(() => {
          index = (index + 1) % messages.length;
          bubble.animate(
            [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-8px)' }],
            { duration: 180, fill: 'forwards' }
          ).finished.then(() => {
            bubble.textContent = messages[index];
            bubble.animate(
              [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration: 240, fill: 'forwards' }
            );
          });
        }, 3600);
      }

      const autoAnimateSelectors = [
        '.cg-about-intro__title', '.cg-about-intro .cg-about-copy',
        '.cg-about-story__header', '.cg-about-evolution__header',
        '.cg-about-difference__header', '.cg-about-difference__card',
        '.cg-about-characters__header', '.cg-about-character',
        '.cg-about-picker__header', '.cg-about-picker__options', '.cg-about-picker__result',
        '.cg-about-work__header', '.cg-about-policy-board__stat',
        '.cg-about-community__header', '.cg-about-community__tile',
        '.cg-about-numbers__header', '.cg-about-number',
        '.cg-about-press__header', '.cg-about-press__logo', '.cg-about-press__card',
        '.cg-about-founder__media', '.cg-about-founder__copy',
        '.cg-about-opportunities__header', '.cg-about-opportunity',
        '.cg-about-ending__inner'
      ];

      let stagger = 0;
      autoAnimateSelectors.forEach((selector) => {
        aboutPage.querySelectorAll(selector).forEach((el, i) => {
          if (!el.hasAttribute('data-cg-animate')) el.setAttribute('data-cg-animate', 'up');
          el.style.setProperty('--cg-delay', `${Math.min((i % 6) * 70, 350)}ms`);
          stagger += 1;
        });
      });

      const revealItems = aboutPage.querySelectorAll('[data-cg-reveal], [data-cg-policy], [data-cg-animate]');
      if ('IntersectionObserver' in window && !reduceMotion.matches) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14, rootMargin: '0px 0px -7% 0px' });
        revealItems.forEach((item) => observer.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }

      aboutPage.querySelectorAll('.cg-about-character').forEach((card) => {
        const button = card.querySelector('.cg-about-character__toggle');
        if (!button) return;
        button.addEventListener('click', () => {
          const isOpen = card.classList.toggle('is-open');
          button.textContent = isOpen ? '×' : '+';
          button.setAttribute('aria-expanded', String(isOpen));
        });
      });

      const pickerButtons = aboutPage.querySelectorAll('.cg-about-picker__button');
      const pickerName = aboutPage.querySelector('[data-picker-name]');
      const pickerMessage = aboutPage.querySelector('[data-picker-message]');
      const pickerImage = aboutPage.querySelector('[data-picker-image]');
      const pickerPlaceholder = aboutPage.querySelector('[data-picker-placeholder]');
      const pickerResult = aboutPage.querySelector('.cg-about-picker__result');

      pickerButtons.forEach((button) => {
        button.addEventListener('click', () => {
          pickerButtons.forEach((item) => item.classList.remove('is-active'));
          button.classList.add('is-active');
          const character = button.dataset.character || '';
          const message = button.dataset.message || '';
          const image = button.dataset.image || '';
          if (pickerName) pickerName.textContent = character;
          if (pickerMessage) pickerMessage.textContent = message;
          if (pickerImage && image) {
            pickerImage.src = image;
            pickerImage.alt = character;
            pickerImage.hidden = false;
            if (pickerPlaceholder) pickerPlaceholder.hidden = true;
          } else if (pickerImage) {
            pickerImage.hidden = true;
            pickerImage.removeAttribute('src');
            if (pickerPlaceholder) pickerPlaceholder.hidden = false;
          }
          if (pickerResult && !reduceMotion.matches) {
            pickerResult.animate(
              [{ transform: 'scale(.985) rotate(-.35deg)' }, { transform: 'scale(1) rotate(0)' }],
              { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' }
            );
          }
        });
      });

      const numberBlocks = aboutPage.querySelectorAll('.cg-about-number');
      if ('IntersectionObserver' in window) {
        const numberObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-counting');
            numberObserver.unobserve(entry.target);
          });
        }, { threshold: 0.55 });
        numberBlocks.forEach((item) => numberObserver.observe(item));
      }
    });
  }

  const boot = () => initAboutPage(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', (event) => initAboutPage(event.target));
})();
